<template>
    <div class="d-flex flex-column" style="min-height: 100vh;">
        <div class="flex-grow-1">
            <FlashMessages/>

            <slot/>
        </div>
    </div>
</template>

<script>
import FlashMessages from '../components/FlashMessages.vue';

export default {
    components: {
        FlashMessages,
    },
};
</script>
